// extracted by mini-css-extract-plugin
export default {"points":"AccordionFaq_points__FGNn4","printScreen":"AccordionFaq_printScreen__DDAdJ"};